var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkunshorten(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.625 4.125H6.375V4.875H2.625V4.125Z",
    fill: "#007BFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 2.625C6.483 2.625 5.517 2.625 5.25 2.625V3.375C5.5395 3.375 6.4605 3.375 6.75 3.375C7.37138 3.375 7.875 3.87862 7.875 4.5C7.875 5.12137 7.37138 5.625 6.75 5.625C6.4605 5.625 5.5395 5.625 5.25 5.625V6.375C5.517 6.375 6.483 6.375 6.75 6.375C7.78538 6.375 8.625 5.53537 8.625 4.5C8.625 3.46462 7.78538 2.625 6.75 2.625ZM2.25 6.375C2.517 6.375 3.483 6.375 3.75 6.375V5.625C3.4605 5.625 2.5395 5.625 2.25 5.625C1.62863 5.625 1.125 5.12137 1.125 4.5C1.125 3.87862 1.62863 3.375 2.25 3.375C2.5395 3.375 3.4605 3.375 3.75 3.375V2.625C3.483 2.625 2.517 2.625 2.25 2.625C1.21463 2.625 0.375 3.46462 0.375 4.5C0.375 5.53537 1.21463 6.375 2.25 6.375Z",
    fill: "#007BFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkunshorten);
export default __webpack_public_path__ + "static/media/linkunshorten.10aa91efc65d61f83251c25048c2ceb5.svg";
export { ForwardRef as ReactComponent };